import { Component, OnInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { empModulo } from '../../diccionarios/empModulo';
import { SeleccionCargasService } from '../seleccion-cargas.service';

@Component({
  selector: 'app-csv-seleccion-promocion',
  templateUrl: './csv-seleccion-promocion.component.html',
  styleUrls: ['./csv-seleccion-promocion.component.css']
})

export class CsvSeleccionPromocionComponent implements OnInit {

  titulo = 'Selección: carga de promoción de empleados';
  public mostrarFormulario = false;
  public modulo: any = empModulo;
  public loading: boolean = false;
  public listaVacia: boolean = true;

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];
  errorData: boolean = true;
  
  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private cargasServices: SeleccionCargasService,
  ){ }

  ngOnInit(): void {
    this.formulario = this.fb.group({ multipart: ['', [Validators.required]] });
    this.cargarGrid();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['COLABORADOR', 'CARGO_ACTUAL_CODE', 'DPTO_ACTUAL_CODE', 'DIRECCION_ACTUAL', 'NIVEL_ORG', 'FECHA_PROMOCION']];
    const data: any[] = [
      {'COLABORADOR': '1312177777', 'CARGO_ACTUAL_CODE': 'L724', 'DPTO_ACTUAL_CODE': 'L724', 'DIRECCION_ACTUAL':'FINANCIERA', 'NIVEL_ORG': '', 'FECHA_PROMOCION': '30-01-2025'}
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  cargarGrid(){
    this.columnDefs = [
      { headerName: 'ESTADO', sortable: true, filter: true, width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      { width: 120, sortable: true, resizable: true, field: 'colaborador' },
      { width: 120, sortable: true, resizable: true, field: 'cargoActualNombre' },
      { width: 120, sortable: true, resizable: true, field: 'dptoNombre' },
      { width: 120, sortable: true, resizable: true, field: 'direccionLF' },
      { width: 120, sortable: true, resizable: true, field: 'cargoPromocion' },
      { width: 120, sortable: true, resizable: true, field: 'dptoNombrePromocion' },
      { width: 120, sortable: true, resizable: true, field: 'direccionLFPromocion' },
      { width: 120, sortable: true, resizable: true, field: 'nivelOrganizacional' },
      { width: 120, sortable: true, resizable: true, field: 'fechaPromocion' },
      { width: 120, sortable: true, resizable: true, field: 'cargaUsuario' },
      { headerName: 'ERROR', field: 'error.errorCampo', filter: true, width: 600, sortable: true, resizable: true, 
        cellStyle: this.changeRowColor.bind(this),
      },
    ];
    this.rowSelection = 'multiple';
  }


  enviarFormulario() {
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    let params = '?usuario='+userData.login2;

    this._util.confirmarSincronoPromesaNormal(
      {
        title : 'Esta seguro que desea enviar el siguiente archivo?',
        text  : this.titulo,
        action: 'Enviar',
        funcion: this.cargasServices.cargaCsvPromocion(this.setFormData(this.formulario.value), params),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title : 'Esta seguro que desea guardar?',
        text  : this.titulo,
        action: 'Guardar',
        funcion: this.cargasServices.saveCargaCsvPromocion(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadDataCsv(){
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {'background-color': 'lightgreen', 'color': 'black', 'font-weight': 'bold'};
      }
      else {
        return {'background-color': '#FFC0CB', 'color': 'black', 'font-weight': 'bold'};
      }
    }
    return true;
  }
}
